/** `<scheme>://dev-login?…`, also with a slash before the query; group 1 is the query string. */
const DEV_LOGIN_LINK = /^[a-z][a-z0-9+.-]*:\/\/dev-login\/?(\?.*)$/i;

/**
 * `<scheme>://dev-login?code=…` is the link the bpp-auth dashboard hands a developer to sign the
 * app in as a Stella person. The scheme is not checked: each stage's build registers only its own
 * (android `devLoginScheme`, iOS CFBundleURLTypes), so the OS delivers no other stage's link.
 * Returns the one-time code, or null for anything else.
 *
 * Matched as a string rather than through `URL`: older WebViews do not split the host out of a
 * custom-scheme URL, so `hostname` would be empty there.
 */
export function getDevLoginCode(url: string): string | null {
  const query = DEV_LOGIN_LINK.exec(url)?.[1];

  if (!query) {
    return null;
  }

  const code = new URLSearchParams(query).get('code')?.trim();

  return code ? code : null;
}
